import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _classPrivateFieldLooseBase from "@babel/runtime/helpers/classPrivateFieldLooseBase";
import _classPrivateFieldLooseKey from "@babel/runtime/helpers/classPrivateFieldLooseKey";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
var _class, _disposed;
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { computed } from 'mobx';
import { fromClock, shareLatest } from '../../../../utils/rxUtil';
import { observeOn, take, takeUntil } from 'rxjs/operators';
import { asapScheduler, Subject } from 'rxjs';
import { task } from 'mobx-task';
import { asAtom } from '../../../../utils/mobxUtil';
export var CallPromptViewModel = (_class = (_disposed = /*#__PURE__*/_classPrivateFieldLooseKey("disposed"), /*#__PURE__*/function () {
  function CallPromptViewModel(call, callStore, getNow) {
    var _this = this;
    _classCallCheck(this, CallPromptViewModel);
    Object.defineProperty(this, _disposed, {
      writable: true,
      value: new Subject()
    });
    this.disposed$ = _classPrivateFieldLooseBase(this, _disposed)[_disposed].pipe(shareLatest(), take(1), observeOn(asapScheduler));
    this.fetch = task(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _this.callStore.fetchCall(_this.call.id);
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    this.call = call;
    this.callStore = callStore;
    this.getNow = getNow;
    this.streams$ = {
      // Using asAtom so we unsub from the clock observable when no longer needed.
      // This ensures that any computed will recompute when the clock emits every
      // second.
      now: asAtom(fromClock(this.getNow).pipe(takeUntil(this.disposed$)), this.getNow())
    };
  }
  return _createClass(CallPromptViewModel, [{
    key: "participants",
    get: function get() {
      return this.call.participants;
    }
  }, {
    key: "duration",
    get: function get() {
      var _this$call$dateComple;
      if (!this.call) {
        return 0;
      }
      var relative = (_this$call$dateComple = this.call.dateCompleted) !== null && _this$call$dateComple !== void 0 ? _this$call$dateComple : this.streams$.now();
      var absolute = relative.valueOf() - this.call.dateCreated.valueOf();
      // Round to the nearest second.
      return absolute - absolute % 1000;
    }
  }, {
    key: "activate",
    value: function activate() {
      //
    }
  }, {
    key: "dispose",
    value: function dispose() {
      _classPrivateFieldLooseBase(this, _disposed)[_disposed].next();
    }
  }]);
}()), _applyDecoratedDescriptor(_class.prototype, "participants", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "participants"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "duration", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "duration"), _class.prototype), _class);
//# sourceMappingURL=CallPromptViewModel.js.map
